import { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  tr: {
    nav: { services: "Hizmetler", tech: "Teknoloji", gallery: "Galeri", warranty: "Garanti", faq: "SSS", contact: "İletişim", cta: "Randevu Al" },
    hero: {
      badge: "35 YIL TECRÜBE · 5 YIL GARANTİ",
      title: ["BOYANIZIN", "ÜZERİNDEKİ", "GÖRÜNMEZ", "ZIRH"],
      sub: "Profesyonel PPF boya koruma filmi, cam filmi ve renk değişim kaplama. Aracınızın değerini yıllarca koruyun.",
      cta1: "Ücretsiz Keşif",
      cta2: "WhatsApp'tan Yaz",
      scroll: "KAYDIR",
    },
    squeegee: {
      kicker: "01 — ŞEFFAF KORUMA",
      title: "FARKI ELİNİZLE GÖRÜN",
      text: "İmleci yüzeyde gezdirin. Mat, çizik ve tozlu boyanın altından HARSPRO ile korunmuş kusursuz parlaklık ortaya çıksın.",
      hint: "İmleci hareket ettirin",
      hintTouch: "Parmağınızı sürükleyin",
    },
    healing: {
      kicker: "02 — SELF-HEALING",
      title: "KENDİNİ ONARAN YÜZEY",
      text: "PPF filmi mikro çiziklere karşı ısıyla kendini onarır. Yüzeyi çizin — birkaç saniye içinde iz bırakmadan kaybolur.",
      scratch: "Çizmek için yüzeye sürükleyin",
      heat: "Isıt",
    },
    beforeAfter: {
      kicker: "03 — ÖNCESİ / SONRASI",
      title: "KORUMASIZ vs HARSPRO",
      text: "Ayırıcıyı sürükleyerek farkı görün. Solda korumasız yıpranmış boya, sağda HARSPRO koruması.",
      before: "KORUMASIZ",
      after: "HARSPRO",
      vehicles: ["SUV", "KAPUT", "COUPE"],
    },
    wrap: {
      kicker: "04 — RENK DEĞİŞİMİ",
      title: "WRAP KONFİGÜRATÖRÜ",
      text: "Bir renk seçin ve aracın gövdesinin sıvı gibi yeni renge büründüğünü izleyin.",
      finishLabel: "FİNİSH",
      colors: [
        { name: "Parlak Siyah", finish: "Parlak", hex: "#0a0a0a", blend: "multiply" },
        { name: "Mat Siyah", finish: "Mat", hex: "#1a1a1a", blend: "multiply" },
        { name: "Saten Mavi", finish: "Saten", hex: "#1e3a8a", blend: "color" },
        { name: "Mat Gri", finish: "Mat", hex: "#4b5563", blend: "color" },
        { name: "Kırmızı", finish: "Parlak", hex: "#b91c1c", blend: "color" },
        { name: "Şampanya", finish: "Metalik", hex: "#c8a568", blend: "color" },
        { name: "Mat Yeşil", finish: "Mat", hex: "#2f5233", blend: "color" },
      ],
    },
    tint: {
      kicker: "05 — CAM FİLMİ",
      title: "ISIYI DIŞARIDA BIRAKIN",
      text: "Film koyuluğunu ayarlayın. Kabin sıcaklığı düşerken ısı reddi yükselsin.",
      darkness: "Film Koyuluğu",
      temp: "İç Sıcaklık",
      rejection: "Isı Reddi",
    },
    services: {
      kicker: "06 — HİZMETLER",
      title: "ÜÇ KATMANLI KORUMA",
      detail: "Detay",
      items: [
        { name: "PPF Boya Koruma", desc: "Görünmez, kendini onaran film ile taş çarpması ve çiziklere karşı tam koruma.", points: ["Taş & çizik koruması", "Kendini onaran yüzey", "10 yıla varan ömür"] },
        { name: "Cam Filmi", desc: "Isı ve UV'yi dışarıda bırakan yüksek performanslı cam filmi.", points: ["%99 UV reddi", "Isı yalıtımı", "Yasal koyuluk seçenekleri"] },
        { name: "Renk Değişimi (Wrap)", desc: "Aracınıza zarar vermeden tamamen yeni bir görünüm.", points: ["Yüzlerce renk & finish", "Geri sökülebilir", "Orijinal boyayı korur"] },
      ],
    },
    timeline: {
      kicker: "07 — 35 YIL",
      title: "USTALIĞIN ZAMAN ÇİZELGESİ",
      countLabel: "YILLIK TECRÜBE",
      milestones: [
        { year: "1989", text: "Otomotiv koruma yolculuğu İstanbul'da başladı." },
        { year: "1998", text: "İlk profesyonel cam filmi uygulamaları." },
        { year: "2008", text: "Boya koruma filmi (PPF) teknolojisine geçiş." },
        { year: "2015", text: "Renk değişim kaplama (wrap) atölyesi açıldı." },
        { year: "2020", text: "Kendini onaran seramik PPF serisi." },
        { year: "2024", text: "35 yıl, binlerce korunan araç, 5 yıl garanti." },
      ],
    },
    process: {
      kicker: "08 — SÜREÇ",
      title: "5 ADIMDA KUSURSUZLUK",
      steps: [
        { t: "Keşif", d: "Aracınızı inceler, ihtiyaca en uygun çözümü belirleriz." },
        { t: "Yüzey Hazırlığı", d: "Detaylı yıkama ve dekontaminasyon ile yüzey hazırlanır." },
        { t: "Kesim", d: "Araca özel dijital kalıplarla film hassas şekilde kesilir." },
        { t: "Uygulama", d: "Tozsuz ortamda uzman ellerle kusursuz uygulama." },
        { t: "Teslim & Garanti", d: "Kalite kontrolü ve 5 yıl garanti kartı ile teslim." },
      ],
    },
    gallery: { kicker: "09 — GALERİ", title: "İŞLERİMİZDEN", text: "Bir görsele tıklayarak tam ekran görüntüleyin." },
    warranty: {
      kicker: "10 — GARANTİ",
      title: "5 YIL GÜVENCE",
      cardTitle: "5 YIL GARANTİ",
      cardSub: "HARSPRO PROTECTION",
      points: ["Sararmaya karşı garanti", "Kabarma & soyulmaya karşı garanti", "Kendini onarma performansı", "Ücretsiz yıllık kontrol"],
      hint: "Kartı hareket ettirin",
    },
    faq: {
      kicker: "11 — SSS",
      title: "SIKÇA SORULANLAR",
      items: [
        { q: "PPF nedir?", a: "PPF (Paint Protection Film), aracın boyasını taş çarpması, çizik ve dış etkenlere karşı koruyan şeffaf, kendini onaran bir poliüretan filmdir." },
        { q: "Kaç yıl dayanır?", a: "Kaliteli PPF, bakımına göre 8-10 yıla kadar dayanır. HARSPRO uygulamalarında 5 yıl garanti sunuyoruz." },
        { q: "Boyaya zarar verir mi?", a: "Hayır. Doğru uygulandığında ve söküldüğünde orijinal boyaya zarar vermez; aksine onu korur." },
        { q: "Renk değişimi geri sökülebilir mi?", a: "Evet. Wrap kaplama, orijinal boyaya zarar vermeden geri sökülebilir." },
        { q: "Cam filmi yasal sınırı nedir?", a: "Türkiye'de ön cam ve ön yan camlarda yasal sınırlar vardır. Uygun koyuluk için sizi bilgilendiririz." },
        { q: "Uygulama ne kadar sürer?", a: "Kapsama göre değişir; tam PPF 2-4 gün, cam filmi ve wrap 1-3 gün sürebilir." },
      ],
    },
    contact: {
      kicker: "12 — İLETİŞİM & RANDEVU",
      title: "ARACINIZI KORUYALIM",
      formTitle: "Randevu Talebi",
      name: "Ad Soyad",
      phone: "Telefon",
      vehicle: "Araç Marka / Model",
      service: "Hizmet",
      serviceOptions: ["PPF Boya Koruma", "Cam Filmi", "Renk Değişimi (Wrap)", "Diğer"],
      note: "Not",
      submit: "WhatsApp ile Gönder",
      sending: "Gönderiliyor...",
      success: "Talebiniz alındı! WhatsApp'a yönlendiriliyorsunuz.",
      error: "Bir hata oluştu, lütfen tekrar deneyin.",
      required: "Lütfen ad ve telefon alanlarını doldurun.",
      addressTitle: "Adres",
      hoursTitle: "Çalışma Saatleri",
      hours: "Pazartesi – Cumartesi: 09:00 – 19:00",
      phoneTitle: "Telefon",
    },
    whatsapp: "WhatsApp",
    footerTagline: "Boyanızın üzerindeki görünmez zırh.",
    rights: "Tüm hakları saklıdır.",
  },

  en: {
    nav: { services: "Services", tech: "Technology", gallery: "Gallery", warranty: "Warranty", faq: "FAQ", contact: "Contact", cta: "Book Now" },
    hero: {
      badge: "35 YEARS · 5 YEAR WARRANTY",
      title: ["THE INVISIBLE", "ARMOR", "OVER YOUR", "PAINT"],
      sub: "Professional PPF paint protection film, window tint and color-change wrap. Preserve your car's value for years.",
      cta1: "Free Inspection",
      cta2: "Message on WhatsApp",
      scroll: "SCROLL",
    },
    squeegee: {
      kicker: "01 — CLEAR PROTECTION",
      title: "SEE THE DIFFERENCE",
      text: "Move the cursor across the surface. Reveal HARSPRO's flawless gloss beneath the dull, scratched paint.",
      hint: "Move the cursor",
      hintTouch: "Drag your finger",
    },
    healing: {
      kicker: "02 — SELF-HEALING",
      title: "A SURFACE THAT HEALS",
      text: "PPF heals micro-scratches with heat. Scratch the surface — it disappears without a trace in seconds.",
      scratch: "Drag across to scratch",
      heat: "Apply Heat",
    },
    beforeAfter: {
      kicker: "03 — BEFORE / AFTER",
      title: "UNPROTECTED vs HARSPRO",
      text: "Drag the divider to compare. Worn, unprotected paint on the left, HARSPRO protection on the right.",
      before: "UNPROTECTED",
      after: "HARSPRO",
      vehicles: ["SUV", "HOOD", "COUPE"],
    },
    wrap: {
      kicker: "04 — COLOR CHANGE",
      title: "WRAP CONFIGURATOR",
      text: "Pick a color and watch the body flow into a brand new finish.",
      finishLabel: "FINISH",
      colors: [
        { name: "Gloss Black", finish: "Gloss", hex: "#0a0a0a", blend: "multiply" },
        { name: "Matte Black", finish: "Matte", hex: "#1a1a1a", blend: "multiply" },
        { name: "Satin Blue", finish: "Satin", hex: "#1e3a8a", blend: "color" },
        { name: "Matte Grey", finish: "Matte", hex: "#4b5563", blend: "color" },
        { name: "Red", finish: "Gloss", hex: "#b91c1c", blend: "color" },
        { name: "Champagne", finish: "Metallic", hex: "#c8a568", blend: "color" },
        { name: "Matte Green", finish: "Matte", hex: "#2f5233", blend: "color" },
      ],
    },
    tint: {
      kicker: "05 — WINDOW TINT",
      title: "KEEP THE HEAT OUT",
      text: "Adjust film darkness. Cabin temperature drops as heat rejection climbs.",
      darkness: "Film Darkness",
      temp: "Cabin Temp",
      rejection: "Heat Rejection",
    },
    services: {
      kicker: "06 — SERVICES",
      title: "THREE LAYERS OF PROTECTION",
      detail: "Details",
      items: [
        { name: "PPF Paint Protection", desc: "Invisible, self-healing film for full protection against rock chips and scratches.", points: ["Rock & scratch protection", "Self-healing surface", "Up to 10-year lifespan"] },
        { name: "Window Tint", desc: "High-performance film that keeps heat and UV outside.", points: ["99% UV rejection", "Heat insulation", "Legal darkness options"] },
        { name: "Color Change (Wrap)", desc: "A brand new look without harming your car.", points: ["Hundreds of colors & finishes", "Removable", "Preserves original paint"] },
      ],
    },
    timeline: {
      kicker: "07 — 35 YEARS",
      title: "A TIMELINE OF CRAFT",
      countLabel: "YEARS OF EXPERIENCE",
      milestones: [
        { year: "1989", text: "The automotive protection journey began in Istanbul." },
        { year: "1998", text: "First professional window tint applications." },
        { year: "2008", text: "Transition to paint protection film (PPF) technology." },
        { year: "2015", text: "Color-change wrap studio opened." },
        { year: "2020", text: "Self-healing ceramic PPF line." },
        { year: "2024", text: "35 years, thousands of protected cars, 5-year warranty." },
      ],
    },
    process: {
      kicker: "08 — PROCESS",
      title: "PERFECTION IN 5 STEPS",
      steps: [
        { t: "Inspection", d: "We inspect your car and define the ideal solution." },
        { t: "Surface Prep", d: "Detailed wash and decontamination prepare the surface." },
        { t: "Cutting", d: "Film is precision-cut with vehicle-specific digital patterns." },
        { t: "Application", d: "Flawless application by experts in a dust-free room." },
        { t: "Delivery & Warranty", d: "Quality check and delivery with a 5-year warranty card." },
      ],
    },
    gallery: { kicker: "09 — GALLERY", title: "OUR WORK", text: "Click an image to view fullscreen." },
    warranty: {
      kicker: "10 — WARRANTY",
      title: "5 YEARS OF ASSURANCE",
      cardTitle: "5 YEAR WARRANTY",
      cardSub: "HARSPRO PROTECTION",
      points: ["Yellowing warranty", "Bubbling & peeling warranty", "Self-healing performance", "Free annual check-up"],
      hint: "Move the card",
    },
    faq: {
      kicker: "11 — FAQ",
      title: "FREQUENTLY ASKED",
      items: [
        { q: "What is PPF?", a: "PPF (Paint Protection Film) is a clear, self-healing polyurethane film that protects paint from rock chips, scratches and the elements." },
        { q: "How long does it last?", a: "Quality PPF lasts up to 8-10 years with care. HARSPRO offers a 5-year warranty." },
        { q: "Does it damage the paint?", a: "No. Applied and removed correctly, it protects rather than harms the original paint." },
        { q: "Is a wrap removable?", a: "Yes. A wrap can be removed without damaging the original paint." },
        { q: "What is the legal tint limit?", a: "Turkey has legal limits for windshield and front side windows. We advise the right darkness for you." },
        { q: "How long does it take?", a: "It depends on scope; full PPF 2-4 days, tint and wrap 1-3 days." },
      ],
    },
    contact: {
      kicker: "12 — CONTACT & BOOKING",
      title: "LET'S PROTECT YOUR CAR",
      formTitle: "Booking Request",
      name: "Full Name",
      phone: "Phone",
      vehicle: "Vehicle Make / Model",
      service: "Service",
      serviceOptions: ["PPF Paint Protection", "Window Tint", "Color Change (Wrap)", "Other"],
      note: "Note",
      submit: "Send via WhatsApp",
      sending: "Sending...",
      success: "Request received! Redirecting to WhatsApp.",
      error: "Something went wrong, please try again.",
      required: "Please fill in name and phone.",
      addressTitle: "Address",
      hoursTitle: "Working Hours",
      hours: "Monday – Saturday: 09:00 – 19:00",
      phoneTitle: "Phone",
    },
    whatsapp: "WhatsApp",
    footerTagline: "The invisible armor over your paint.",
    rights: "All rights reserved.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("tr");
  const toggle = useCallback(() => setLang((l) => (l === "tr" ? "en" : "tr")), []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}

// Shared contact constants — replace with real HARSPRO number (user did not provide yet).
export const CONTACT = {
  whatsapp: "905000000000", // TODO: replace with real HARSPRO WhatsApp number
  instagram: "https://www.instagram.com/harsproturkiye",
  instagramHandle: "@harsproturkiye",
  phoneDisplay: "+90 (5xx) xxx xx xx",
  address: "Saadetdere Mah. E5 Yan Yolu No: 65, Haramidere, Esenyurt, İstanbul",
  mapEmbed:
    "https://www.google.com/maps?q=Saadetdere+Mah.+E5+Yan+Yolu+No+65+Haramidere+Esenyurt+Istanbul&output=embed",
};

export function waLink(message) {
  return `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;
}
